import { useEffect } from "react";
import { useAppDispatch } from "@/hooks/storeHooks.ts";
import "bootstrap/dist/css/bootstrap.min.css";
import PageContainer from "./Layout/PageContainer/PageContainer.tsx";
import "react-toastify/dist/ReactToastify.css";
import { setIsLoggedInAction } from "./actions/generalActions.ts";
import { getInitialDataAction } from "./actions/importActions.ts";
import "fmv-component-ui-library/fmv-component-ui-library.css";
import { NotificationContainer } from "fmv-component-ui-library";

const App = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      window.location.hostname.includes("logp") ||
      window.location.hostname.includes("localhost")
    ) {
      dispatch(setIsLoggedInAction(true));
      dispatch(getInitialDataAction());
    }
  }, [dispatch]);

  return (
    <div id="AppContainer">
      <NotificationContainer />
      <PageContainer />
    </div>
  );
};

export default App;
